// Cache the main tree container
const treeContainer = document.querySelector('.nav-tree');

// Event delegation on the tree container for click events
treeContainer.addEventListener('click', event => {
  const toggler = event.target.closest('.cursor');
  if (!toggler || !treeContainer.contains(toggler) || toggler.closest('li.no-child')) return;
  toggleBranch(toggler);
  updateCursorTabindexes();
});

// Event delegation on the tree container for keydown events
treeContainer.addEventListener('keydown', event => {
  const toggler = event.target.closest('.cursor');
  if (!toggler || !treeContainer.contains(toggler) || toggler.closest('li.no-child')) return;
  switch (event.key) {
    case 'Enter':
    case ' ':
      event.preventDefault();
      toggleBranch(toggler);
      updateCursorTabindexes();
      break;
    case 'ArrowRight':
      event.preventDefault();
      if (toggler.getAttribute('aria-expanded') === 'false') {
        toggleBranch(toggler);
        updateCursorTabindexes();
      } else {
        const child = getFirstChildToggler(toggler);
        if (child) child.focus();
      }
      break;
    case 'ArrowLeft':
      event.preventDefault();
      if (toggler.getAttribute('aria-expanded') === 'true') {
        toggleBranch(toggler);
        updateCursorTabindexes();
      } else {
        const parent = getParentToggler(toggler);
        if (parent) parent.focus();
      }
      break;
    case 'ArrowUp':
      event.preventDefault();
      focusPrevToggler(toggler);
      break;
    case 'ArrowDown':
      event.preventDefault();
      focusNextToggler(toggler);
      break;
  }
});

// Toggles branch state and updates aria-expanded
const toggleBranch = toggler => {
  const treeItem = toggler.closest('li[role="treeitem"]');
  const isOpen = toggler.getAttribute('aria-expanded') === 'true';
  toggler.setAttribute('aria-expanded', !isOpen);
  treeItem.classList.toggle('is-open', !isOpen);
};

// Update tabindex for all .cursor elements:
// If inside li.no-child, remove tabindex and set aria-hidden="true"; otherwise, visible togglers get tabindex "0", hidden ones "-1"
const updateCursorTabindexes = () => {
  document.querySelectorAll('.nav-tree .cursor').forEach(toggler => {
    if (toggler.closest('li.no-child')) {
      toggler.removeAttribute('tabindex');
      toggler.setAttribute('aria-hidden', 'true');
    } else {
      toggler.removeAttribute('aria-hidden');
      toggler.setAttribute('tabindex', toggler.offsetParent !== null ? '0' : '-1');
    }
  });
};

// Returns the first child toggler within the group controlled by the given toggler
const getFirstChildToggler = toggler => {
  const controlledId = toggler.getAttribute('aria-controls');
  const group = controlledId && document.getElementById(controlledId);
  return group ? group.querySelector('.cursor') : null;
};

// Returns the parent toggler from the parent group
const getParentToggler = toggler => {
  const parentGroup = toggler.closest('ul[role="group"]');
  const parentTreeItem = parentGroup && parentGroup.closest('li[role="treeitem"]');
  return parentTreeItem ? parentTreeItem.querySelector('.cursor') : null;
};

// Returns an array of visible togglers that are not inside li.no-child
const getVisibleTogglers = () =>
  Array.from(document.querySelectorAll('.nav-tree .cursor')).filter(
    toggler => !toggler.closest('li.no-child') && toggler.offsetParent !== null
  );

// Focus the previous visible toggler
const focusPrevToggler = current => {
  const visible = getVisibleTogglers();
  const index = visible.indexOf(current);
  if (index > 0) visible[index - 1].focus();
};

// Focus the next visible toggler
const focusNextToggler = current => {
  const visible = getVisibleTogglers();
  const index = visible.indexOf(current);
  if (index !== -1 && index < visible.length - 1) visible[index + 1].focus();
};

// Loads the tree via AJAX and calls setBranchToggler (event delegation is already active)
function loadTree() {
  if (!treeLoaded) {
    const url = '/?ajax=eshopmenu&url=' + nav_url,
          querySelector = '.nav-tree--ajax',
          position = 'afterbegin',
          fnAfter = 'setBranchToggler';
    loadData(url, '', querySelector, position, fnAfter);
    window.treeLoaded = 1;
  }
}

loadTree();